export const EXCLUDED_SUBDOMAINS = ['rusin-stage', 'rusin-uat', 'app', 'my', 'localhost'];
